module.exports = __webpack_public_path__ + "img/Mention.6ba7869b.svg";